//This is the main function of a Chart.

/**
 * @param {Object} container - DOM element in which the chart will be rendered
 * @param {(Object | Array)} data - Data for the chart
 * @returns {Object} Main chart object
 */
import anychart from "anychart"
import { formatMinutesAsDuration } from "../../../utils/durationUtils";
import { isoFormat, formatDateFullTime, formatDateTime, formatDate, formatTime, formatDateTimeISO } from "../../../utils/dateTimeUtils";      
const language = localStorage.getItem('language') || 'en'

let activeNowMarkerIntervalId = null;

export const gantChart = (container, data, onClickHandler, colors, startDate, endDate, companyKey, ganttDarkMode, company, openActivities, featureFlags, showHeader) => {
    function nowDate() {
        const now = new Date();
        let offset = now.getTimezoneOffset() * 60000;
        return new Date(now.getTime() - offset);
    }

    var fromDate = new Date(startDate);
    var toDate = new Date(endDate);
    toDate.setHours(toDate.getHours() - 1);

    //function to remove anychart credits
    function removeElementsByClass() {
        const elements = document.getElementsByClassName("anychart-credits");
        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    };

    function checkIfContainsData(text) {
        if (!text || text === "#NA") {
            return false;
        }
        return true;
    }

    // Create Gantt project chart.
    var chart = anychart.ganttResource();

    // Set the data for the chart
    chart.data(data, "as-tree");

    // set start splitter position settings
    chart.splitterPosition(0);

    // get chart data grid link to set column settings
    var dataGrid = chart.dataGrid();

    if (ganttDarkMode === "true") {
        dataGrid.rowEvenFill("none");
        dataGrid.rowFill("none");
        dataGrid.headerFill("none")
        dataGrid.rowHoverFill("none");
    } else {
        dataGrid.rowFill("#ffffff 1");
        dataGrid.rowEvenFill("#ffffff 1");
        dataGrid.headerFill("#ffffff 1")
        dataGrid.rowHoverFill("#e9e9e9 0.8");
    }
    dataGrid.columnStroke("2 #434957");
    dataGrid.columnStroke("1 #434957");
    dataGrid.columnStroke("0 #434957");
    dataGrid.rowStroke("#ffffff");

    // hide first column
    dataGrid.column(0).enabled(false);
    dataGrid.enabled(false);

    // get chart timeline
    var timeLine = chart.getTimeline();

    // set base fill
    timeLine.elements().fill(function () {
        // get status from data item
        var status = this.period.status;
        var statusColor = this.period.color;

        // create fill object
        var fill = {
            // if this element has children, then add opacity to it
            opacity: this.item.numChildren() ? 1 : 0.9
        };
        fill.color = statusColor;
        // set fill color by status


        return fill;
    });
    timeLine.columnStroke(null);

    if (ganttDarkMode === "true") {
        timeLine.rowHoverFill("none");
        timeLine.rowFill("none");
        timeLine.rowEvenFill("none");
    } else {
        timeLine.rowHoverFill("#e9e9e9 0.8");
        timeLine.rowEvenFill("ffffff 1");
        timeLine.rowFill("#ffffff 1");
    }
    timeLine.rowStroke("#101624 0.8");

    // set base stroke
    timeLine.elements().stroke('none');

    var header = chart.getTimeline().header();
    // if (ganttDarkMode === "true") {
    //     header.fill("none");
    //     header.fontColor("#ffffff");
    // } else {
    //     header.fill("#ffffff");
    //     header.fontColor("none");
    // }
    // header.stroke("#101624 0.8");

    // set first column settings
    var firstColumn = dataGrid.column(1);
    firstColumn.labels().hAlign('left');
    firstColumn
        .title('Machine')
        .width(200)
        .labels()
        .format(function () {
            return this.name;
        });

    // set first column settings

    chart.getTimeline().scale().zoomLevels([
        [
            { unit: "hour", count: 1 },
            { unit: "day", count: 1 }
        ]
    ]);

    // set container id for the chart
    //chart.container('chart_container');
    if (showHeader === true) {
        var header = chart.getTimeline().header();
        header.fill("#434957");
        header.fontColor("#ffffff");
        header.stroke("#101624 0.8");
        header.level(0).format("{%tickValue}{dateTimeFormat:HH:00 }");
        header.level(1).format("{%tickValue}{dateTimeFormat:yyyy-MM-dd}");
    }
    else {
        var header2 = chart.getTimeline().header();
        header2.level(0).enabled(false);
        header2.level(1).enabled(false);
        header2.level(1).height(0);
        header2.level(0).height(0);
    }
    if (language === "en") {
        var header = chart.getTimeline().header();
        header.level(0).format("{%tickValue}{dateTimeFormat:hh a}");
    }
    // configure tooltips of the timeline
    chart.dataGrid().tooltip(false);
    chart.getTimeline().tooltip().useHtml(true);
    if (language === "en") {
        chart.getTimeline().tooltip().format(function () {
            if (!this.period) { return "" }
            return "" +
                `Start: ${anychart.format.dateTime(this.start, "MM/dd/yyyy hh:mm a")}<br> ` +
                `End: ${anychart.format.dateTime(this.end, " MM/dd/yyyy hh:mm a")}<br>` +
                `Duration: ${formatMinutesAsDuration(this.period.duration)}<br>` +
                `Stop Reason: <b>${this.period.status}</b><br>` +
                (checkIfContainsData(this.period.itemId) ? `Item: ${this.period.itemId ?? ""}<br>` : "") +
                (checkIfContainsData(this.period.productionOrderId) ? `Production order: ${this.period.productionOrderId ?? ""}<br>` : "") +
                (checkIfContainsData(this.period.comment) ? `Comment: ${this.period.comment ?? ""}<br>` : "") +
                `Updated By: ${this.period.UpdatedBy ?? ""}`
        });
    }
    if (language === "sv") {
        chart.getTimeline().tooltip().format(function () {
            if (!this.period) { return "" }
            return "" +
                `Start: ${anychart.format.dateTime(this.start, "yyyy-MM-dd HH:mm")}<br> ` +
                `Slut: ${anychart.format.dateTime(this.end, "yyyy-MM-dd HH:mm")}<br>` +
                `Längd: ${formatMinutesAsDuration(this.period.duration)}<br>` +
                `Stopporsak: <b>${this.period.status}</b><br>` +
                (checkIfContainsData(this.period.itemId) ? `Artikel: ${this.period.itemId ?? ""}<br>` : "") +
                (checkIfContainsData(this.period.productionOrderId) ? `Produktionsorder: ${this.period.productionOrderId ?? ""}<br>` : "") +
                (checkIfContainsData(this.period.comment) ? `Kommentar: ${this.period.comment ?? ""}<br>` : "") +
                `Uppdaterad av: ${this.period.UpdatedBy ?? ""}`
        });
    }

    timeLine.elements()
        .labels()
        .enabled(true)
        .fontColor('#fff')
        .format(function () {
            var comment = this.period.comment;
            var label = this.label;
            if (comment != null) {
                if (comment.length > 1) {
                    comment = '*';
                } else {
                    comment = '';
                }
            } else {
                comment = '';
            }
            return comment;

        })
        .textShadow({
            color: '#333333',
            offsetX: '1px',
            offsetY: '1px',
            blurRadius: '1px'
        });

    timeLine.scale().minimum(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), (fromDate.getHours()), fromDate.getMinutes(), fromDate.getSeconds()));
    timeLine.scale().maximum(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), (toDate.getHours() + 1), toDate.getMinutes(), toDate.getSeconds()));

    // Add a vertical line marker to the timeline
    var nowMarker = timeLine.lineMarker().value(nowDate()).stroke("white", 2, "4 2").layout("vertical");

    // Update the marker every minute (or faster if needed)
    if (activeNowMarkerIntervalId) {
        clearInterval(activeNowMarkerIntervalId);
        activeNowMarkerIntervalId = null;
    }

    let nowMarkerIntervalId = setInterval(function () {
        nowMarker.value(nowDate());
    }, 60 * 1000); // update every 60 seconds
    activeNowMarkerIntervalId = nowMarkerIntervalId;

    // Clear the interval when the chart is disposed to avoid leaks and stale callbacks
    chart.listen("dispose", function () {
        console.log("dispose disposing:");
        const disposedIntervalId = nowMarkerIntervalId;
        if (nowMarkerIntervalId) {
            clearInterval(nowMarkerIntervalId);
            nowMarkerIntervalId = null;
        }

        if (activeNowMarkerIntervalId === disposedIntervalId) {
            activeNowMarkerIntervalId = null;
        }
    });

    chart.listen("rowClick", function (e) {
        e.preventDefault();
    });
    chart.listen("rowDblClick", function (e) {

        if (e.elementType == "periods") {
            //codeStopModal(e.period.id,  parseInt(e.item.get("id")));
            onClickHandler(e.period.id)
            var itemName = e.item.get("name");
        }
    });

    // Set correct Zoom level
    chart.fitAll();

    // Set container for the chart
    chart.container(container);

    chart.background("none");
    chart.defaultRowHeight(15);

    // Draw the chart in the container
    chart.draw();
    removeElementsByClass();
    // set the text of the second data grid column

    var column_2 = chart.dataGrid().column(1);
    column_2.labels().useHtml(true);
    column_2.title().fontColor("#ffffff");

    column_2.labels().format(function () {

        var numChildren = this.item.numChildren();
        //var duration = (this.end - this.start) / 1000 / 3600 / 24;
        var customField = " ";
        if (this.getData("custom_field")) {
            customField = "<span style='font-weight:bold'>" +
                this.getData("custom_field") + customField + "</span>";
        }

        var parentText = "<span style='color:gray;font-weight:bold'>" +
            this.name.toUpperCase() + "<span>";

        var childText = "<span style='color:#ffffff;font-weight:bold'>" + this.name + "<span>";


        // identify the resource type and display the corresponding text
        if (numChildren > 0) {
            return parentText;
        } else {
            return childText;
        }

    });

    //Return Chart object
    return chart;
};
